import script from "./feedback-form.vue?vue&type=script&setup=true&lang=js"
export * from "./feedback-form.vue?vue&type=script&setup=true&lang=js"

import "./feedback-form.vue?vue&type=style&index=0&id=5d140752&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d140752"]])

export default __exports__